// A derivação do SLUG a partir do título, num lugar só.
//
// Puro, sem UM import, com prova própria (`app/tests/slug.mjs`).
//
// ---------------------------------------------------------------------------
// Por que isto é um módulo de uma função
// ---------------------------------------------------------------------------
// O slug é a IDENTIDADE da obrigação: é por ele que `etl/carregar-calendario.mjs`
// faz upsert, e é ele que decide se a carga ATUALIZA a linha existente ou CRIA
// uma nova. Quando a tela de admin passou a criar obrigação à mão (000112 em
// diante), passaram a existir duas pontas derivando slug — e duas derivações que
// discordam numa vírgula fazem a próxima carga criar 20 duplicatas do catálogo,
// em silêncio, porque `on conflict (slug)` não casa mais.
//
// É o mesmo defeito de "agregar acesso em JavaScript" com outra roupa: a segunda
// definição da mesma regra. Então a função saiu do ETL e virou este arquivo, que
// o front importa normalmente e o ETL carrega transpilando (o mesmo caminho de
// `calendarioFiscal.ts`).
//
// A prova cobra os 20 slugs REAIS que já estão gravados: se um só divergir, ela
// falha — porque o preço do erro não é uma linha torta, é o catálogo dobrado.

/**
 * Título → slug. Sem acento, sem caixa, sem pontuação, cortado em 60.
 *
 * O corte é em 60 e não em 200 (o limite do título) porque slug é para caber em
 * URL e em log; e o `replace` final existe porque cortar no meio de um separador
 * deixaria um hífen pendurado — `dirpf-declaracao-de-ajuste-anual-do-imposto-de-`
 * seria um slug diferente do mesmo título amanhã, se o corte caísse noutro lugar.
 */
export function slugDeTitulo(titulo: string): string {
  return String(titulo)
    .normalize("NFD")
    // A faixa dos diacríticos combinantes (U+0300–U+036F). Escrita por código de
    // propósito: escrita como caractere literal, ela sobrevive mal a cópia entre
    // arquivos e a heredoc de shell — e o modo de falha é silencioso, com o
    // acento passando batido para dentro do slug.
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^A-Za-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase()
    .slice(0, 60)
    .replace(/-+$/, "");
}
